// removed by extract-text-webpack-plugin
module.exports = {"Container":"_2g8TQbf66clJQ9w-mb-UAD","Title":"_12P37DTPQh2RTtzF3Wiycv","FeeGroup":"_39bykSCa1KP6ybNzBPu8I8","FeeGroupTitle":"_3w6zZJWkR7kwC7UQ5LVouC","FeeGroupDescription":"_2j2hmKfxdPUX_vA-Ixwx5N","FieldRow":"_11OB0HcWEa0VRJoCRfZ1cV","Field":"_9SgzokLKJGqetHDCVsGRq","FieldLabel":"_2eiB1nNltAMENhUDW2OJbK","FieldInput":"_1_AxZuBNmQaGBPVChi0Ndr","FieldHint":"_1RRe4iHLSYzokSESDj_ZLn","SaveBtn":"_1mtLQSYQLti7px5flNDqns","StatusMsg":"T4QST8NSgBw_hl_qZk9rO","StatusSuccess":"_16nuxO1kHt4pZ4xZ8LLLG2","StatusError":"_1G-wq8CA66118Wg44sI2fJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/TerminalFeesTab/styles.module.css
// module id = 581
// module chunks = 0